import {useCallback} from 'react';
import {useHistory} from 'react-router-dom';

import {useReduxStore} from '../../../state/hooks';
import {type Ref as PanelBankSectionConfigRef} from '../../../state/views/panelBankSectionConfig/types';
import {type LayedOutPanel} from '../../../util/panelTypes';
import {useSharedPanelStateMaybe} from '../SharedPanelStateContext';
import {appendZoomParamsToURL} from '../zoomURLUtils';
import {getSharePanelLink} from './fullScreenUtils';

export const useGetFullScreenPanelLink = (
  panel: LayedOutPanel,
  panelBankSectionConfigRef: PanelBankSectionConfigRef | undefined
) => {
  const history = useHistory();
  const store = useReduxStore();
  const {userZoomState} = useSharedPanelStateMaybe() ?? {};

  return useCallback(() => {
    // We should never hit this state when trying to go full screen in a workspace.
    // Right now, both workspaces and reports share the same panel header, but reports
    // will never have a sectionConfigRef associated. Once panel header is decoupled,
    // we can then remove this check and tighten the types.
    const panelBankSectionName =
      panelBankSectionConfigRef == null
        ? ''
        : store.getState().views.parts[panelBankSectionConfigRef.type][
            panelBankSectionConfigRef.id
          ]?.name;

    let link = getSharePanelLink(panel, panelBankSectionName, history.location);
    if (userZoomState) {
      link = appendZoomParamsToURL(link, userZoomState);
    }
    return link;
  }, [history, panel, panelBankSectionConfigRef, store, userZoomState]);
};
